import { component } from '@arcade/web'
import * as tokens from '@cash-design-system/tokens'

import { ArcadeThemeColorsOverride } from './arcadeColors'
import { ThemeColorsOverride } from './colors'

/**
 * This is a theme that exists soley to override the color of text in the primary button, making
 * it black to match the Cash Afterpay theme in AP checkout.
 */
const palette = {
  ColorPaletteBlack: '#000000',
}

export const cashAfterpayArcadeColors: Partial<ArcadeThemeColorsOverride> = {
  buttonProminentTextDefault: {
    light: palette.ColorPaletteBlack,
    dark: component.buttonProminentTextDefault.dark,
  },
}

export const cashAfterpayMooncakeColors = {
  primaryButtonTint: {
    light: palette.ColorPaletteBlack,
    dark: tokens.ColorButtonPrimaryTintDark,
  },
  disabled: {
    light: palette.ColorPaletteBlack,
    dark: '#80eaa7', // note: can't use the palette or tokens here beacuse of circular references
  },
} as ThemeColorsOverride
